import { Injectable } from "@angular/core";
import { Mailing } from "../models/mailings/mailing.model";
import { BaseService } from "./base.service";
import { Observable } from "rxjs";
import { IToken } from "@beefree.io/sdk/dist/types/bee";

@Injectable({
    providedIn: 'root'
})
export class MailingsService extends BaseService<Mailing> {
    private readonly apiUrl = '/api/mailings';

    public BeeLogin(): Observable<IToken> {
        return this.http.post<IToken>(`${this.apiUrl}/bee/login`, {});
    }
}